import { render } from "./BasicLeadsNumCard.vue?vue&type=template&id=4337cdb8"
import script from "./BasicLeadsNumCard.vue?vue&type=script&lang=js"
export * from "./BasicLeadsNumCard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__